import React from 'react'
import { NavLink } from 'react-router-dom'
import { ArrowForwardIos } from '@material-ui/icons'
import { StyledCrumb, StyledColoredText } from './styled'

export interface ICrumbItem {
  text: string
  accentedText: string
  linkTo: string
  autoClassName?: string
  theme?: 'group' | 'portal'
}
export interface ICrumb {
  item: ICrumbItem
  isLast: boolean
}

export const Crumb = ({
  item: { text, accentedText, linkTo, autoClassName = '', theme = 'portal' },
  isLast,
}: ICrumb) => (
  <>
    <StyledCrumb className={autoClassName}>
      <NavLink to={linkTo}>
        {text}{' '}
        <StyledColoredText theme={theme}>{accentedText}</StyledColoredText>
      </NavLink>
    </StyledCrumb>
    {!isLast && <ArrowForwardIos />}
  </>
)
